module.exports = __webpack_public_path__ + "img/sepa.d73b92c8.svg";